import * as React from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {emailGotAction, emailGotInvalidAction} from '../../store/actions';
import {emailSelector} from '../../store/selectors';
import {EmailForm} from '../EmailForm/EmailForm';
import {SmallParagraph} from '../ui/SmallParagraph/SmallParagraph';
import {Subtitle} from '../ui/Subtitle/Subtitle';
import styles from './GetEmailPage.scss';
import {IOuter} from './GetEmailPage.types';

export const GetEmailPageComponent: React.FunctionComponent<IOuter> = ({submitText, subTitle, footer}) => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const onSubmit = ({email}) => dispatch(emailGotAction({email}));
  const onValidationFailed = ({errorMsg}) => dispatch(emailGotInvalidAction({errorMsg}));
  const email = useSelector(emailSelector);

  return (
    <div className={styles.getEmailPage}>
      <Subtitle className={styles.subtitle}>{subTitle || t('mgw.enterYourEmailSubtitle')}</Subtitle>
      <EmailForm
        initialEmail={email}
        onSubmit={({email}) => onSubmit({email})}
        submitButtonText={submitText || t('mgw.enterYourEmailToProceed')}
        onValidationFailed={onValidationFailed}
      />
      {footer && <SmallParagraph dataHook="footer-remark">{footer}</SmallParagraph>}
    </div>
  );
};

GetEmailPageComponent.displayName = 'GetEmailPage';
